(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class TextShowMore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.text-block');
      this.toggle = this.querySelector('.text-block-show-more__toggle');
      if (!this.content || !this.toggle) return;

      this.expanded = false;
      this.update();

      this.toggle.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.content.classList.toggle('is-collapsed', !this.expanded);
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.toggle.textContent = this.expanded ? this.toggle.dataset.lessLabel : this.toggle.dataset.moreLabel;
      });

      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      if (this.expanded) {
        this.toggle.hidden = false;
        return;
      }
      // While collapsed the content is clamped + overflow:hidden, so a
      // scrollHeight greater than clientHeight means text is being hidden.
      this.content.classList.add('is-collapsed');
      const overflows = this.content.scrollHeight > this.content.clientHeight + 1;
      this.toggle.hidden = !overflows;
    }
  }

  if (!customElements.get('text-show-more')) {
    customElements.define('text-show-more', TextShowMore);
  }
  } catch(e) { console.error(e); }
})();

})();
